import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";

export default function PqcProductPage() {
    useEffect(() => {
        document.title = "PQC Readiness Platform — Syntera Technologies";
    }, []);

    return (
        <div className="flex h-screen flex-col bg-ink" data-testid="pqc-product-page">
            <Navbar />
            <main className="mt-[72px] flex-1">
                <iframe
                    src="/pqc-readiness-platform.html"
                    title="PQC Readiness Platform, Syntera Technologies"
                    data-testid="pqc-platform-frame"
                    className="h-full w-full border-0"
                />
            </main>
        </div>
    );
}
